import { Component, OnInit, OnDestroy, ViewChild, ElementRef, DoCheck, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Subscription } from 'rxjs';
import { NgbModal, ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import { Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { DomSanitizer } from '@angular/platform-browser';
import { Foodcourt } from 'src/app/model/foodcourt.model';
import { AddfoodvendorService } from 'src/app/services/addfoodvendor.service';
import { FoodcourtService } from 'src/app/services/foodcourt.service';
import { DateService } from 'src/app/services/date.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  standalone: false,
  selector: 'app-update-food-court',
  templateUrl: './update-food-court.component.html',
  styleUrls: ['./update-food-court.component.scss']
})
export class UpdateFoodCourtComponent implements OnInit {

  public foodcourt = new Foodcourt();
  private subscriptions = new Subscription();
  public accordianIcon = '../../../assets/images/icons/chevron_up.svg';

  prakList: any = [];
  finalSubmissionArray = [];
  afterConvertFile: any = [];
  images = [];
  activeIds: string[] = ['form_row_01', 'form_row_02', 'form_row_03'];
  currentProcessingImg: any = 0;
  imgId: any = 0;
  finalImageList: any = [];
  photoData: any = {};
  uploadData: any;
  selectedPark = localStorage.getItem('parkId');
  parkDetails;
  displayPark = '';
  daysOfOperation = [];
  foodCourtList: any = [];
  foodCourtId: any;
  mainFoodCourtList = [];
  newmainFoodCourtList = [];
  foodcourtDeepCopy: any;
  newMainFoodCourts: any;

  myForm = new FormGroup({
    FoodCourtName: new FormControl(),
    ParkId: new FormControl(),
  });

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private sideNavService: SidenavService,
    private appStateSrv: AppStateProvider,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private acroute: ActivatedRoute,
    private dateAdapter: NgbDateAdapter<string>,
    private dateSrv: DateService,
    private addfoodvendorService: AddfoodvendorService,
    private foodcourtService: FoodcourtService,
    private commonService: CommonService,
    private route: ActivatedRoute,
  ) {
    this.myForm = this.formBuilder.group({
      FoodCourtName: ['', [Validators.required, Validators.maxLength(100)]],
      ParkId: [''],
    });

    localStorage.setItem('expandNavFoodCourt', 'true');
    const routeLink = this.sideNavService.routingChunks({
      name: 'Food Court Management',
      subNav: '1',
      subNavLink: '',
    });
    this.appStateSrv.setSideNavState(routeLink);
  }

  ngOnInit(): void {

    this.route.params.subscribe((params) => {
      this.foodCourtId = params['id'];
    });

    localStorage.removeItem('expandNav');
    localStorage.removeItem('expandNavLand');
    localStorage.removeItem('expandNavCreateview');
    this.selectedPark = localStorage.getItem('parkId');

    this.foodcourt.ParkId = '';

    this.subscriptions = this.commonService.parkDropDownDetailsArray.subscribe(
      (res) => {
        this.parkDetails = res;
        this.parkDetails = this.parkDetails.length > 0 ? this.parkDetails : JSON.parse(localStorage.getItem('parkDropDownDetails'));
        this.selectedPark = localStorage.getItem('parkId');
        if (this.parkDetails != null && this.selectedPark == null) {
          this.displayPark = this.parkDetails[0].parkName + ', ' + this.parkDetails[0].cityName;
        } else if (this.parkDetails != null && this.selectedPark) {
          this.parkDetails.forEach((element) => {
            if (element.parkId === this.selectedPark) {
              this.displayPark = element.parkName + ', ' + element.cityName;
            }
          });
        }
      }
    );
    this.getTheFoodCourtList();
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavCreateview');
    this.subscriptions.unsubscribe();
  }

  getParkDetails() {
    this.foodcourtService.getParkByCLAId().subscribe((res) => {
      if (res.isValid) {
        this.prakList = res.list;
      }
    });
  }

  goToListPage() {
    this.router.navigate(['/list-food-court/']);
  }

  onSubmit(): void {
    console.log(this.myForm.value);

    this.finalSubmissionArray = [];
    this.finalSubmissionArray.push({
      "FoodCourtId": this.foodCourtId,
      "FoodCourtName": this.myForm.value.FoodCourtName,
      "ParkId": localStorage.getItem('parkId'),
      "ModifiedBy": localStorage.getItem('claAdminId')
    });

    if (this.myForm.valid) {
      this.foodcourtService
        .updateFoodCort(this.finalSubmissionArray[0])
        .subscribe((res) => {
          this.router.navigate(['/list-food-court/']);
        });
    } else {
      this.myForm.markAllAsTouched();
    }
  }

  getTheFoodCourtList() {
    this.foodcourtService.mainFoodCourtList().subscribe((res) => {
      if (res?.isValid === true) {
        this.mainFoodCourtList = res?.list;
        // this.newmainSurveyList = res?.list;
        this.newmainFoodCourtList = res?.list.filter((item: { foodCourtId: any }) => {
          return item.foodCourtId === this.foodCourtId;
        });
        console.log(this.newmainFoodCourtList[0].foodCourtName);
        this.foodcourt.FoodCourtName = this.newmainFoodCourtList[0].foodCourtName;
        console.log(this.foodcourt.FoodCourtName);
      } else {
        this.mainFoodCourtList = [];
      }
    });
  }

}
